const retrieveProjectSritState = {
    SearchProject: '',
    // userToken: '', // 用户token
    isLoginState: false, // 登录状态
    isAdv: false,
    Navs:'',
};

export default retrieveProjectSritState;